export default __webpack_public_path__ + "img/PIC_HE_Reliability_fw_de_de_92802.jpg";